import axiosInstance from "./axiosInstance";

const url = '/post'

export const savePost = (data, submit) => axiosInstance.post(url, data, { params: { submit } });

export const getAllPosts = (filter) => axiosInstance.get(`${url}`, { params: filter });

export const getPostById = (id) => axiosInstance.get(`${url}`, { params: { id } });
